import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=5468d6b4&scoped=true"
import script from "./permission.vue?vue&type=script&lang=jsx"
export * from "./permission.vue?vue&type=script&lang=jsx"
import style0 from "./permission.vue?vue&type=style&index=0&id=5468d6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5468d6b4",
  null
  
)

export default component.exports